<!-- Page Content -->
<div class="content">
    <div class="container">
        <div class="row">
            <div class="col-md-6 offset-md-3">

                <!-- Login Content -->
                <div class="account-content">
                    <div class="align-items-center justify-content-center">
                        <div class="login-right">
                            <div class="login-header text-center">
                                <a [routerLink] = "'/home'"><img src="assets/img/logo-01.png" alt="logo" class="img-fluid"></a>
                                <h3>¿Olvidaste tu contraseña?</h3>
                                <p>Bríndanos tu correo y te guiaremos para recuperarla.</p>
                              <div class="error-container">
                                <div *ngIf="resetError">{{resetErrorMessage}}</div>
                              </div>
                              <div class="success-container">
                                <div *ngIf="resetSuccess && submitted">Te enviamos un correo con instrucciones para recuperar tu contraseña</div>
                                <div *ngIf="resetSuccess && submitted">Ingresa <a [routerLink]="'/login'" class="link-primary">aquí</a> </div>
                              </div>
                            </div>
                          <Form [formGroup]="loginForm" (ngSubmit)="enviar(loginForm.value)">
                            <div class="form-group form-focus">
                              <input formControlName="email" type="text" class="form-control floating">
                              <label class="focus-label"  [ngClass]="{'filled': loginForm.controls.email.value}">Email</label>
                            </div>
                            <button class="btn btn-primary btn-block btn-lg login-btn" type="submit">Recuperar</button>
                            <div class="row">
                              <div class="col-5 text-start">
                                <a class="forgot-link" [routerLink] = "'/'">¿Ya estás registrado?</a>
                              </div>
                              <div class="col-7 text-end dont-have">¿Eres nuevo en Mercado Cheque? <a class="text-nowrap" [routerLink] = "'/register'">Click aquí</a></div>
                            </div>
                          </Form>

<!--                                <div class="login-or">-->
<!--                                    <p>Or login with</p>-->
<!--                                </div>-->
<!--                                <div class="row social-login">-->
<!--                                    <div class="col-4">-->
<!--                                        <a href="#" class="btn btn-twitter btn-block"> Twitter</a>-->
<!--                                    </div>-->
<!--                                    <div class="col-4">-->
<!--                                        <a href="#" class="btn btn-facebook btn-block"> Facebook</a>-->
<!--                                    </div>-->
<!--                                    <div class="col-4">-->
<!--                                        <a href="#" class="btn btn-google btn-block"> Google</a>-->
<!--                                    </div>-->
<!--                                </div>-->
                        </div>
                    </div>
                </div>
                <!-- /Login Content -->

            </div>
        </div>
    </div>
</div>
<!-- /Page Content -->
